<template>
  <div v-if="isReady" class="content animate-panel" id="home">
    <top-banner :images="topBanner" />
    <div class="mr-t-20 text-gray">
      <div class="row font-bold">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 equal-box">
          <div class="card">
            <div class="card-title">
              <i class="fa fa-jpy" aria-hidden="true"></i> 本日の売上金額
            </div>
            <div v-if="amountsData.length > 0" class="card-content text-right">
              <div class="">
                <span class="text-size-32">{{ formatNumber(amountsData[0].value) }}</span> {{ amountsData[0].unit }}
              </div>
              <div v-if="amountsData[0].rate >= 0" class="text-green">
                <i class="fa fa-long-arrow-up" aria-hidden="true"></i> {{ Math.abs(amountsData[0].rate) }}%
              </div>
              <div v-else class="text-orange">
                <i class="fa fa-long-arrow-down" aria-hidden="true"></i> {{ Math.abs(amountsData[0].rate) }}%
              </div>
              <table-sales-growth :columns="amountColumns" :data="amountsData.slice(1)" />
              <div class="mr-t-10">
                <button class="btn btn-primary" @click="handleClickViewAnalysis()">
                  さらに表示する
                  <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div v-else class="text-center">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 equal-box">
          <div class="card">
            <div class="card-title">
              <i class="fa fa-line-chart" aria-hidden="true"></i> 本日の注文件数
            </div>
            <div v-if="ordersData.length > 0" class="card-content text-right">
              <div class="">
                <span class="text-size-28">{{ formatNumber(ordersData[0].value) }}</span> {{ ordersData[0].unit }}
              </div>
              <div v-if="ordersData[0].rate >= 0" class="text-green">
                <i class="fa fa-long-arrow-up" aria-hidden="true"></i> {{ Math.abs(ordersData[0].rate) }}%
              </div>
              <div v-else class="text-orange">
                <i class="fa fa-long-arrow-down" aria-hidden="true"></i> {{ Math.abs(ordersData[0].rate) }}%
              </div>
              <table-sales-growth :columns="ordersColumns" :data="ordersData.slice(1)" />
              <div class="mr-t-10">
                <button class="btn btn-primary" @click="handleClickViewAnalysis()">
                  さらに表示する
                  <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div v-else class="text-center">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 equal-box">
          <div class="card">
            <div class="card-title">
              <i class="fa fa-shopping-cart" aria-hidden="true"></i> 本日の販売個数
            </div>
            <div v-if="salesData.length > 0" class="card-content text-right">
              <div class="">
                <span class="text-size-28">{{ formatNumber(salesData[0].value) }}</span> {{ salesData[0].unit }}
              </div>
              <div v-if="salesData[0].rate >= 0" class="text-green">
                <i class="fa fa-long-arrow-up" aria-hidden="true"></i> {{ Math.abs(salesData[0].rate) }}%
              </div>
              <div v-else class="text-orange">
                <i class="fa fa-long-arrow-down" aria-hidden="true"></i> {{ Math.abs(salesData[0].rate) }}%
              </div>
              <table-sales-growth :columns="salesColumns" :data="salesData.slice(1)" />
              <div class="mr-t-10">
                <button class="btn btn-primary" @click="handleClickViewAnalysis()">
                  さらに表示する
                  <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div v-else class="text-center">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 equal-box">
          <div class="card">
            <div class="card-title">
              <i class="fa fa-reply" aria-hidden="true"></i> 本日の返品個数
            </div>
            <div v-if="returnsData.length > 0" class="card-content text-right">
              <div class="">
                <span class="text-size-28">{{ formatNumber(returnsData[0].value) }}</span> {{ returnsData[0].unit }}
              </div>
              <div v-if="returnsData[0].rate >= 0" class="text-green">
                <i class="fa fa-long-arrow-up" aria-hidden="true"></i> {{ Math.abs(returnsData[0].rate) }}%
              </div>
              <div v-else class="text-orange">
                <i class="fa fa-long-arrow-down" aria-hidden="true"></i> {{ Math.abs(returnsData[0].rate) }}%
              </div>
              <table-sales-growth :columns="returnsColumns" :data="returnsData.slice(1)" />
              <div class="mr-t-10">
                <button class="btn btn-primary" @click="handleClickViewAnalysis()">
                  さらに表示する
                  <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div v-else class="text-center">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="row font-bold" id="warehouse-status">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 equal-box">
          <div class="card">
            <div class="card-title">
              <img class="w-30" src="/static/dists/img/ic_SaleMonster24.png">
              セールモンスター
            </div>
            <div v-if="warehousesData" class="card-content salemonster-info">
              <div class="usage-plan">
                <span>ご利用プラン</span>
                <div class="text-size-32 text-right" :class="{ 'plan-basic-text': isBasicPlan, 'plan-premium-text': !isBasicPlan}">
                  <span>{{ plan }}</span>
                  <span v-if="isPremiumTrial" class="text-size-20">(トライアル)</span>
                </div>
                <div>
                  <button v-if="isBasicPlan || isPremiumTrial" class="btn btn-primary" @click="handleClickJoinPremium()">
                    プレミアム登録はコチラ
                    <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div class="items-available-sale">
                <span>出品可能数</span>
                <div class="flex gap-10" style="flex: 1; justify-content: right; align-items: baseline;">
                  <span>残り</span>
                  <div class="text-green">
                    <span class="text-size-28">{{ formatNumber(warehousesData.available) }}</span>
                    <span class="">件</span>
                  </div>
                </div>
                <div>
                  <button class="btn btn-primary" @click="handleClickAddAvailableQuantity()">
                    出品可能数を追加する
                    <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div class="review-status">
                <span>審査状況</span>
                <div style="flex: 1;">
                  <div class="flex gap-10" style="justify-content: right; align-items: baseline;">
                    <span>審査中</span>
                    <div class="text-green">
                      <span class="text-size-28">{{ formatNumber(warehousesData.review) }}</span>
                      件
                    </div>
                  </div>
                  <div class="flex gap-10" style="justify-content: right; align-items: baseline;">
                    <span>出品中</span>
                    <div class="text-green">
                      <span class="text-size-28">{{ formatNumber(warehousesData.sale) }}</span>
                      件
                    </div>
                  </div>
                  <div class="flex gap-10" style="justify-content: right; align-items: baseline;">
                    <span>審査NG</span>
                    <div class="text-red">
                      <span class="text-size-28">{{ formatNumber(warehousesData.reject) }}</span>
                      件
                    </div>
                  </div>
                </div>
                <div>
                  <button class="btn btn-primary" @click="handleClickRequestReconsideration()">
                    再審査を依頼する
                    <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div v-else class="text-center">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 equal-box">
          <div class="card">
            <div class="card-title">
              <img class="w-30" src="https://image-yoshino.sakura.ne.jp/monster/SaleMonLogi.png">
              セルモンロジ
            </div>
            <div class="card-content">
              <div class="selmon-logi">
                <div class="selmon-logi-across">
                  <div>
                    <img class="w-30" :src="iconUrls['salmonAcross']">
                    <span>ACROSS倉庫</span>
                  </div>
                  <div class="selmon-logi-info">
                    <span>ご利用状況</span>
                    <span v-if="warehouseAcrossUsed" class="text-size-28 text-green">利用中</span>
                    <span v-else class="text-size-28 text-red">未利用</span>
                    <div style="flex: 1; text-align: right; align-self: center;">
                      <button v-if="warehouseAcrossUsed" class="btn btn-primary" @click="handleClickOpenWarehouse('salmonAcross')">
                        ACROSS倉庫を開く
                        <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                      </button>
                      <button v-else class="btn btn-primary" @click="handleClickGetStarted('salmonAcross')">
                        利用を開始する
                        <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="selmon-logi-sc">
                  <div>
                    <img class="w-30" :src="iconUrls['salmonSc']">
                    <span>STOCKCREW倉庫</span>
                  </div>
                  <div class="selmon-logi-info">
                    <span>ご利用状況</span>
                    <span v-if="warehouseScUsed" class="text-size-28 text-green">利用中</span>
                    <span v-else class="text-size-28 text-red">未利用</span>
                    <div style="flex: 1; text-align: right; align-self: center;">
                      <button v-if="warehouseScUsed" class="btn btn-primary" @click="handleClickOpenWarehouse('salmonSc')">
                        STOCKCREW倉庫を開く
                        <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                      </button>
                      <button v-else class="btn btn-primary" @click="handleClickGetStarted('salmonSc')">
                        利用を開始する
                        <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 equal-box">
          <div class="card">
            <div class="card-title">
              <img class="w-30" src="https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png">
              セルモンエージェント通知
            </div>
            <div class="card-content">
              <div v-if="userInfo.hasReturnRecommend" class="fba-longterm fba-longterm-across">
                <div class="fba-longterm-content">
                  <div>FBAで無駄な手数料が <span class="text-primary text-size-28">{{ formatNumber(userInfo.totalFbaFee) }}</span> 円発生しています！</div>
                  <div class="text-right">
                    <button class="btn btn-warning" @click="$router.push('/salemon-agent')">
                      エージェント画面を開く
                      <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="isBasicPlan || this.isPremiumTrial" class="fba-longterm-sc">
                <span>
                  売上アップにつながる商品をお知らせ <i class="fa fa-envelope-o" aria-hidden="true"></i> ワンクリックで出品！
                </span>
                <div class="full-width text-right mr-t-10">
                  <button class="btn btn-primary" @click="$router.push('/setting/plan-info')">
                    プレミアム登録はコチラ
                    <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              <div v-else-if="userInfo.countSelmonProductsAvailable > 0" class="fba-longterm">
                <div class="fba-longterm-content">
                  <div>商品を <span class="text-primary text-size-28">{{ formatNumber(userInfo.countSelmonProductsAvailable) }}</span> 件出品して、売上アップにつなげよう！</div>
                  <div class="text-right">
                    <button class="btn btn-warning" @click="$router.push('/salemon-agent/product-available')">
                      エージェント画面を開く
                      <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 equal-box">
          <div class="card">
            <div class="card-title">
              <i class="fa fa-bullhorn" aria-hidden="true"></i> お知らせ
            </div>
            <div v-if="notices.length > 0" class="card-content text-size-14">
              <div v-for="(notice, index) in notices" :key="index" class="border-bottom-dotted flexbox gap-10 hover-pointer" @click="handleViewNotice(notice)">
                <span>{{ notice.date }}</span>
                <span>
                  <a
                    href="javascript:void(0)"
                    v-html="replaceHTMLSellerInfo(notice.title)"
                    >
                  </a>
                </span>
              </div>
            </div>
            <div v-else class="text-center">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 equal-box">
          <div class="card">
            <div class="card-title">
              <i class="fa fa-calendar-o" aria-hidden="true"></i> イベント情報
            </div>
            <div v-if="eventData" class="flex flex-flow-column text-size-14 card-content">
              <a v-for="(item, index) in eventData" :key="index" :href="item.destUrl" @click="!item.destUrl && $event.preventDefault()" class="border-bottom-dotted" target="_blank">
                {{ item.content }}
                <i class="fa fa-external-link" aria-hidden="true"></i>
              </a>
            </div>
            <div v-else class="text-center">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 equal-box">
          <div class="card">
            <div class="card-title">
              <i class="fa fa-book" aria-hidden="true"></i> マニュアル
            </div>
            <div v-if="manualData" class="flex flex-flow-column text-size-14 card-content">
              <a v-for="(item, index) in manualData" :key="index" :href="item.destUrl" @click="!item.destUrl && $event.preventDefault()" class="border-bottom-dotted" target="_blank">
                {{ item.content }}
                <i class="fa fa-external-link" aria-hidden="true"></i>
              </a>
            </div>
            <div v-else class="text-center">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-for="(item, i) in bottomBanner" :key="i" class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
          <a :href="item.destUrl" @click="!item.destUrl && $event.preventDefault()" target="_blank">
            <img :src="item.content" class="full-width">
          </a>
        </div>
      </div>
    </div>
    <modal-amazon-expiration v-if="isShowModalAmazonExpiration && amazonExpirationContext.length"
      :amazonExpirationContext="amazonExpirationContext"></modal-amazon-expiration>
  </div>
</template>

<script>
import Util, { replaceHTMLSellerInfo } from '@/common/utility'
import ModalAmazonExpiration from '@/components/ModalAmazonExpiration'
import TopBanner from '@/components/Slider'
import TableSalesGrowth from './components/TableSalesGrowth'
import HomeService from '@/services/homeservice'
import { mapGetters } from 'vuex'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    ModalAmazonExpiration,
    TopBanner,
    TableSalesGrowth
  },
  data () {
    return {
      isReady: false,
      loader: null,
      amountColumns: ['日付', '売上金額', '前日比'],
      ordersColumns: ['日付', '注文件数', '前日比'],
      salesColumns: ['日付', '販売個数', '前日比'],
      returnsColumns: ['日付', '返品個数', '前日比'],
      topBanner: [],
      amountsData: [],
      ordersData: [],
      salesData: [],
      returnsData: [],
      warehousesData: null,
      eventData: null,
      manualData: null,
      bottomBanner: []
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser',
      notices: 'getNotices',
      analysisSubmenu: 'getAnalysisMenu',
      iconUrls: 'getWareHouseIcons'
    }),
    isShowModalAmazonExpiration () {
      let isShowModal = false
      if (this.userInfo.sellerId && localStorage.getItem('isShowModalAmazonExpiration')) {
        isShowModal = true
      }
      return isShowModal
    },
    amazonExpirationContext () {
      /*
        Explain about value expireAt
          1 => 0 ~ 31 days and show modal
          2 => > 31 days and hide modal
          3 => < 0 days and show modal
          4 => null and show modal
      */

      if (!this.userInfo.hasSpAccount || (this.userInfo.hasSpAccount && this.userInfo.enableFlag === false)) {
        return [{
          text: 'セールモンスターへ出品する場合は、Amazonとのデータ連携が必要です。',
          classes: ''
        }]
      }
      if (this.userInfo.hasSpAccount && this.userInfo.enableFlag === null) {
        return [
          {
            text: 'Amazon側のシステム変更により、',
            classes: ''
          },
          {
            text: '2022年12月31日までにAmazonとのデータ連携を設定して頂く必要があります。',
            classes: 'text-danger text--underline font-weight-normal'
          },
          {
            text: '実施頂けない場合、2023年1月以降にセールモンスターからの出品ができなくなります。',
            classes: 'mr-b-10'
          },
          {
            text: '※既にデータ連携が完了しているセラー様も、再度設定して頂く必要があります。',
            classes: 'text-danger text--underline mr-b-10 font-weight-normal'
          },
          {
            text: 'お手数おかけしますが、よろしくお願いいたします。',
            classes: 'mr-b-10'
          }
        ]
      }
      if (this.userInfo.hasSpAccount && this.userInfo.enableFlag && this.userInfo.expireAt === 1) {
        return [
          {
            text: '有効期限が近づいています。',
            classes: 'text-danger text--underline mr-b-10 font-weight-normal'
          },
          {
            text: '以下のボタンより再設定を行ってください。',
            classes: 'mr-b-10'
          }
        ]
      }
      if (this.userInfo.hasSpAccount && this.userInfo.enableFlag && this.userInfo.expireAt === 3) {
        return [
          {
            text: '有効期限が切れました。',
            classes: 'text-danger text--underline font-weight-normal'
          },
          {
            text: 'セールモンスターへ出品する場合は、再度Amazonとのデータ連携が必要です。',
            classes: 'mr-b-10'
          },
          {
            text: '以下のボタンより再設定を行ってください。',
            classes: 'mr-b-10'
          }
        ]
      }
      return []
    },
    isBasicPlan () {
      return this.userInfo.memberPlan === '0'
    },
    isPremiumTrial () {
      return this.userInfo.isPremiumTrial
    },
    plan () {
      if (this.isBasicPlan) {
        return 'ベーシック'
      }

      return 'プレミアム'
    },
    warehouseScUsed () {
      return this.userInfo.scWarehouseUse === '1'
    },
    warehouseAcrossUsed () {
      return this.userInfo.acrossAgreeFlg === '1'
    },
    analysisId () {
      return this.analysisSubmenu.length > 0 ? this.analysisSubmenu[0].seq : null
    }
  },
  async mounted () {
    let logParams = {
      name: eventCode.home.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
    await this.getTopBanner()

    this.getSalesData()
    this.getWarehousesData()
    this.getEventData()
    this.getManualData()
    this.getBottomBanner()
  },
  methods: {
    replaceHTMLSellerInfo,
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    async getTopBanner () {
      this.loader = this.$loading.show()
      await HomeService.getTopBanner()
        .then(response => {
          this.topBanner = response.data
        })
        .catch(err => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
        .finally(() => {
          this.isReady = true
          this.loader && this.loader.hide()
        })
    },
    getSalesData () {
      HomeService.getSalesData()
        .then(response => {
          this.amountsData = response.data.amounts
          this.ordersData = response.data.orders
          this.salesData = response.data.sales
          this.returnsData = response.data.returns
        })
        .catch(err => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    getWarehousesData () {
      HomeService.getWarehousesData()
        .then(response => {
          this.warehousesData = response.data
        })
        .catch(err => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    getEventData () {
      HomeService.getEventData()
        .then(response => {
          this.eventData = response.data
        })
        .catch(err => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    getManualData () {
      HomeService.getManualData()
        .then(response => {
          this.manualData = response.data
        })
        .catch(err => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    getBottomBanner () {
      HomeService.getBottomBanner()
        .then(response => {
          this.bottomBanner = response.data
        })
        .catch(err => {
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    handleViewNotice (notice) {
      this.$router.push(`/Notices?scroll_to=${notice.id}`)
    },
    handleClickViewAnalysis () {
      if (this.analysisId) {
        this.$router.push({name: 'Analysis', params: {id: this.analysisId}})
      }
    },
    handleClickJoinPremium () {
      if (!this.isBasicPlan) {
        return false
      }
      this.$router.push('/setting/plan-info')
    },
    handleClickAddAvailableQuantity () {
      this.$router.push('/setting/service-info')
    },
    handleClickRequestReconsideration () {
      this.$router.push('/products-new/list')
    },
    handleClickGetStarted (type) {
      this.$router.push({name: 'Warehouses', query: {name: type}})
    },
    handleClickOpenWarehouse (type) {
      if (type === 'salmonAcross') {
        this.$router.push('/warehouse-across/top')
      }

      if (type === 'salmonSc') {
        this.$router.push('/warehouse-sc/top')
      }

      return false
    }
  }
}
</script>
<style>
  #home {
    .animate-panel {
      padding-right: 5px !important;
    }
    .text-gray {
      color: #666;
    }
    .card {
      background: #fff;
      border-radius: 6px;
      padding: 15px;
      margin-bottom: 30px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      flex: 1 1 0;
      flex-direction: column;
      min-height: 175px;
      font-size: 20px;
    }
    .card-title {
      border-bottom: 10px solid #e2f0d9;
      font-weight: bold;
      font-size: 20px;
    }
    .card-content {
      margin: 10px 10px 0 10px;
    }
    .card-content-table {
      display: flex;
      width: 100%;
      justify-content: end;
    }
    .card-content-table table {
      width: 100%;
    }
    .card-content-table table th, .card-content-table table td{
      font-weight: normal;
      font-size: 16px;
      text-align: right;
      padding: 5px;
    }
    .card-content-table table td{
      border-bottom: 2px dotted #bfbfbf;
    }
    .border-bottom {
      border-bottom: 2px solid #bfbfbf;
    }
    .border-bottom-dotted {
      border-bottom: 1px dotted #bfbfbf;
      padding: 5px 0;
    }
    .row {
      display: flex;
      flex-wrap: wrap;
    }
    .equal-box {
      display: flex;
    }
    .text-orange {
      color: #ed7d31;
    }
    .text-green {
      color: #70AD47;
    }
    .text-size-32 {
      font-size: 32px;
    }
    .btn {
      min-width: 190px;
    }
    .hover-pointer:hover {
      cursor: pointer;
    }
    .fba-longterm {
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      gap: 10px;
      margin-top: 10px;
    }
    .fba-longterm-across {
      border-bottom: 3px dotted #ccc;
      padding-bottom: 10px;
    }
    .fba-longterm-sc {
      font-size: 16px;
      padding: 10px;
    }
    .fba-longterm-icon {
      animation: fuwafuwa 3s ease-in-out infinite alternate;
      background: url(https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png) no-repeat center center / 90px auto;
      display: inline-block;
      transition: 1.5s ease-in-out;
      width: 100px;
      height: 100px;
    }
    .fba-longterm-content {
      display: flex;
      font-size: 18px;
      flex-direction: column;
      width: 100%;
      color: #fff;
      background: linear-gradient(0deg, #ffb347, #ff5858);
      padding: 10px;
      border-radius: 8px;
      gap: 20px;
    }
    .btn-warning {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      height: fit-content;
      border-radius: 4px;
      border: 1px solid #595959;
      padding: 3px 12px;
      color: #666;
    }
    .salemonster-info {
      display: flex;
      flex-direction: column;
      gap: 10px;
      word-break: keep-all;
      line-height: 30px;
    }
    .salemonster-info .usage-plan {
      flex-wrap: wrap;
      border-bottom: 3px dotted #ccc;
      padding-bottom: 10px;
      .plan-premium-text, .plan-basic-text {
        white-space: break-spaces;
        flex: 1;
      }
    }
    .salemonster-info .items-available-sale {
      flex-wrap: wrap;
    }
    .salemonster-info .review-status {
      flex-wrap: wrap;
      div:has(button) {
        align-self: end;
      }
    }
    .salemonster-info > div {
      display: flex;
      justify-content: end;
      align-items: baseline;
      gap: 10px;
      white-space: nowrap;
      div:has(button) {
        align-self: start;
      }
    }
    .selmon-logi {
      display: flex;
      flex-direction: column;
      gap: 20px;
      font-weight: bold;
    }
    .selmon-logi .selmon-logi-across {
      border-bottom: 3px dotted #ccc;
      padding-bottom: 10px;
    }
    .selmon-logi .selmon-logi-info {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: baseline;
      gap: 10px;
      margin-left: 60px;
      white-space: nowrap;
    }
  }

  @media (min-width: 1441px) and (max-width: 1919px) {
    #home .text-size-32.plan-premium-text, #home .text-size-32.plan-basic-text{
      font-size: 28px;
    }
    #home .card {
      padding: 10px;
    }
  }

  @media (min-width: 1025px) and (max-width: 1440px) {
    #home .col-lg-4 {
      width: 50%;
    }
    #home .col-lg-3 {
      width: 50%;
    }
  }

  @media (max-width: 1024px) {
    #home .text-size-32.plan-premium-text, #home .text-size-32.plan-basic-text{
      font-size: 24px;
    }
  }

  @media (max-width: 325px) {
    .usage-plan > span {
      flex: 1;
    }
  }

  @keyframes fuwafuwa {
    0% {
      transform:translate(0, 0) rotate(-7deg);
    }
    50% {
      transform:translate(0, -7px) rotate(0deg);
    }
    100% {
      transform:translate(0, 0) rotate(7deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/home/Home.vue